import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useSelector } from 'react-redux';

import { BuilderContainer } from './Builder';
import { BuildersBlock } from '../../components/BuildersBlock';
import { Layout } from '../../components/Layout';
import { getBuilders, getNewbuildingId } from '../../selectors/newbuilding';
import { trackContactBlockShow } from '../Agents/tracking';

export function BuildersContainer() {
  const builders = useSelector(getBuilders);
  const newbuildingId = useSelector(getNewbuildingId);

  const showHandler = React.useCallback(() => {
    trackContactBlockShow(newbuildingId, 'builders');
  }, [newbuildingId]);

  if (builders.length === 0) {
    return null;
  }

  if (builders.length === 1) {
    return (
      <ActionAfterViewObserver triggerOnce callback={showHandler} percentVisible={0.8}>
        <Layout>
          <BuilderContainer builder={builders[0]} />
        </Layout>
      </ActionAfterViewObserver>
    );
  }

  return (
    <ActionAfterViewObserver triggerOnce callback={showHandler} percentVisible={0.8}>
      <BuildersBlock>
        {builders.map(builder => (
          <BuilderContainer key={builder.id} builder={builder} />
        ))}
      </BuildersBlock>
    </ActionAfterViewObserver>
  );
}
